import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import * as i0 from "@angular/core";
export class PaymentValidityGuard {
    canActivate(next, state) {
        let valid = localStorage.getItem('valid').toString();
        return valid == '01';
    }
}
PaymentValidityGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PaymentValidityGuard_Factory() { return new PaymentValidityGuard(); }, token: PaymentValidityGuard, providedIn: "root" });
